module.exports = __webpack_public_path__ + "static/media/images360Marker.e8eecb45.svg";